import { render, staticRenderFns } from "./staff-detail.vue?vue&type=template&id=36a962ff&scoped=true&"
import script from "./staff-detail.vue?vue&type=script&lang=js&"
export * from "./staff-detail.vue?vue&type=script&lang=js&"
import style0 from "./staff-detail.vue?vue&type=style&index=0&id=36a962ff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a962ff",
  null
  
)

export default component.exports